module.exports = __webpack_public_path__ + "img/11.d400897.svg";